import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {VorhersageHeute, VorhersageTag, VorhersageZehnTage} from '../../../../../../model/vorhersagen/vorhersage-zehn-tage';
import {DatastoreService} from '../../../../../../service/datastore/datastore.service';
import {map, take} from 'rxjs/operators';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-drei-stunden-vorhersage',
  templateUrl: './drei-stunden-vorhersage.component.html',
  styleUrls: ['../vorhersagen-table-styles.css']
})
export class DreiStundenVorhersageComponent implements OnInit {
  selectedVorhersage: VorhersageZehnTage;
  isLoading = false;

  constructor(public route: ActivatedRoute,
              public datastoreService: DatastoreService,
              private firebaseService: FirebaseService,
              private snackbar: MatSnackBar) {
  }

  ngOnInit() {
    //Die computer-mos Komponente übergibt beim Routing auf die Details den Namen/Id der Station als Parameter,
    // der bei der Initialisierung ausgelesen wird und das entsprechenden Objekt herausgeholt
    this.route.queryParams.subscribe(params => {
      if (params.id !== null && params.id !== undefined) {
        this.isLoading = true;
        this.getZehnTageVorhersagen3h(params.id);
      }
    });
  }

  private getZehnTageVorhersagen3h(id: string) {
    return this.firebaseService.getVorhersagenDeutschland10Tage3hByID(id)
      .pipe(take(1), map(data => this.datastoreService.mapDataTo3hZehnTageVorhersagen(data)))
      .subscribe(() => {
        this.selectedVorhersage = this.datastoreService.vorhersagen3hZehnTage[0];
        this.isLoading = false;
      }, error => {
        this.snackbar.open(`ERROR: Konnte Vorhersagen nicht laden ${error}`);
        this.isLoading = false;
      });
  }
}
